import React from 'react';
import { FaCheck, FaExclamationTriangle, FaInfoCircle, FaEnvelope } from 'react-icons/fa';

const EmailStatus = ({ status, type = 'info', message, onClose }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'success':
        return {
          icon: <FaCheck className="text-green-600" />,
          bgColor: 'bg-green-50',
          borderColor: 'border-green-200',
          textColor: 'text-green-800',
          title: 'Success!'
        };
      case 'error':
        return {
          icon: <FaExclamationTriangle className="text-red-600" />,
          bgColor: 'bg-red-50',
          borderColor: 'border-red-200',
          textColor: 'text-red-800',
          title: 'Error'
        };
      case 'sending':
        return {
          icon: <FaEnvelope className="text-blue-600" />,
          bgColor: 'bg-blue-50',
          borderColor: 'border-blue-200',
          textColor: 'text-blue-800',
          title: 'Sending...'
        };
      default:
        return {
          icon: <FaInfoCircle className="text-gray-600" />,
          bgColor: 'bg-gray-50',
          borderColor: 'border-gray-200',
          textColor: 'text-gray-800',
          title: 'Information'
        };
    }
  };

  const config = getStatusConfig();

  if (!status || !message) return null;

  return (
    <div className={`${config.bgColor} ${config.borderColor} border rounded-lg p-4 mb-4`}>
      <div className="flex items-start">
        <div className="flex-shrink-0 mr-3">
          {status === 'sending' ? (
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
          ) : (
            config.icon
          )}
        </div>
        <div className="flex-1">
          <h4 className={`${config.textColor} font-semibold text-sm mb-1`}>
            {config.title}
          </h4>
          <p className={`${config.textColor} text-sm`}>
            {message}
          </p>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="flex-shrink-0 ml-3 text-gray-400 hover:text-gray-600"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default EmailStatus;
